import { jsxs as i, jsx as t } from "react/jsx-runtime";
import { forwardRef as r, useState as d } from "react";
import l from "./styles.module.less.js";
const C = r(
  (e, n) => {
    var s;
    const [a, o] = d(!1);
    return e.text ? /* @__PURE__ */ i(
      "div",
      {
        className: l.tooltipContainer,
        onMouseEnter: () => o(!0),
        onMouseLeave: () => o(!1),
        children: [
          /* @__PURE__ */ i(
            "svg",
            {
              width: "16",
              height: "16",
              viewBox: "0 0 16 16",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg",
              className: l.tooltipIcon,
              children: [
                /* @__PURE__ */ t(
                  "path",
                  {
                    d: "M7.5 11L7.5 7C7.5 6.72386 7.72386 6.5 8 6.5C8.27614 6.5 8.5 6.72386 8.5 7V11C8.5 11.2761 8.27614 11.5 8 11.5C7.72386 11.5 7.5 11.2761 7.5 11Z",
                    fill: "#191919"
                  }
                ),
                /* @__PURE__ */ t(
                  "path",
                  {
                    d: "M7.5 5C7.5 4.72386 7.72386 4.5 8 4.5C8.27614 4.5 8.5 4.72386 8.5 5C8.5 5.27614 8.27614 5.5 8 5.5C7.72386 5.5 7.5 5.27614 7.5 5Z",
                    fill: "#191919"
                  }
                ),
                /* @__PURE__ */ t(
                  "path",
                  {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M1.5 8C1.5 4.41015 4.41015 1.5 8 1.5C11.5899 1.5 14.5 4.41015 14.5 8C14.5 11.5899 11.5899 14.5 8 14.5C4.41015 14.5 1.5 11.5899 1.5 8ZM2.5 8C2.5 4.96243 4.96243 2.5 8 2.5C11.0376 2.5 13.5 4.96243 13.5 8C13.5 11.0376 11.0376 13.5 8 13.5C4.96243 13.5 2.5 11.0376 2.5 8Z",
                    fill: "#191919"
                  }
                )
              ]
            }
          ),
          a && /* @__PURE__ */ i(
            "div",
            {
              ref: n,
              ...e.props,
              className: `${l.questionTooltip} ${((s = e.props) == null ? void 0 : s.className) || ""}`,
              children: [
                /* @__PURE__ */ t("div", { className: l.title, children: e.title }),
                /* @__PURE__ */ t("div", { className: l.description, children: e.text })
              ]
            }
          )
        ]
      }
    ) : null;
  }
);
C.displayName = "QuestionTooltip";
export {
  C as QuestionTooltip
};
